import React from "react";
import { FaChevronRight } from "react-icons/fa";

const HotelDetailBreadcrumbs = ({ city, hotelName, isMobile = false }) => {
    return (
        <nav
            style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "8px",
                fontSize: isMobile ? "0.75rem" : "0.85rem",
                color: "#EE2E24",
                marginBottom: "15px",
                fontFamily: "'Lato', sans-serif",
                fontWeight: "600",
                lineHeight: "1.4"
            }}
        >
            <span style={{ cursor: "pointer" }}>Home</span>
            <FaChevronRight size={10} color="#666" />
            <span style={{ cursor: "pointer" }}>Hotels In {city}</span>
            <FaChevronRight size={10} color="#666" />
            <span style={{ color: "#444", fontWeight: "600" }}>{hotelName}</span>
        </nav>
    );
};

export default HotelDetailBreadcrumbs;
